import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from 'src/app/core/services/login.service';
import { SlsService } from 'src/app/core/services/sls.service';
import { ToastService } from 'src/app/core/toast.service';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { FeedService } from '../../services/feed.service'; 
import { FeedUrlVideoComponent } from '../feed-url-video/feed-url-video.component';
import { FeedDocumentComponent } from '../feed-document/feed-document.component';
import { FeedImageComponent } from '../feed-image/feed-image.component';
import { FeedVideoComponent } from '../feed-video/feed-video.component';

@Component({
  selector: 'app-add-newsfeed-popup',
  templateUrl: './add-newsfeed-popup.component.html',
  styleUrls: ['./add-newsfeed-popup.component.scss']
})
export class AddNewsfeedPopupComponent implements OnInit {
  newsfeeds: any[] = [];
 
  isLoading = false;
  subscriptionPermissions: any;
  categoriesFilter: any[] = [];
  // @Inject(MAT_DIALOG_DATA) public data: any
  newsfeedForm: FormGroup;
  isEditMode = false;
  selectedFile: File | null = null;
  urlPattern = /^(https?:\/\/)?(www\.)?[\w\-]+(\.[\w\-]+)+([\/\w\-._~:?#[\]@!$&'()*+,;=]*)?$/;
  uploadedFiles: any[] = [];
  validationError: any;
  imageurl: any[] = [];
  categories: any[] = [];
  constructor(private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddNewsfeedPopupComponent>,
    private fb: FormBuilder,
    public feedService: FeedService,
    public loginService: LoginService,
    private toast: ToastService,
    private mediaService: MediaService,
    private sls: SlsService,

  ) {
    this.newsfeedForm = this.fb.group({
      description: ['', Validators.required],
      category_type: ['', Validators.required],
      video_url: ['',this.youtubeLoomVimeoUrlValidator],
      post_image: '',
      web_url: "",
      user_role: '',
      user_id: '',
      status: ""

    });
  }
  youtubeLoomVimeoUrlValidator(control: AbstractControl): ValidationErrors | null {
    const url = control.value;
    if (!url) {
      return null;
    }
    const youtubeRegex = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
    const loomRegex = /^(https?\:\/\/)?(www\.)?(loom\.com\/share\/.+)$/;
    const vimeoRegex = /^(https?\:\/\/)?(www\.)?(vimeo\.com\/.+)$/;
    const isValidUrl = youtubeRegex.test(url) || loomRegex.test(url) || vimeoRegex.test(url);
    return isValidUrl ? null : { invalidVideoUrl: true };
  }

  ngOnInit(): void {
       this.loadUserNewsfeeds();
    this.checkCategoryPermissions();
    if (this.data) {
      this.isEditMode = true;
      this.newsfeedForm.patchValue(this.data)
      this.uploadedFiles = this.data.post_image.map(image => ({
        id:image.id,
        name: image.name,
        type: image.type,
        url: image.url,
      }));
    }
    const loginData = this.loginService.getLoginData();
    this.feedService.getNewsFeedsCategories().subscribe(data => {
      this.categories = data;
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getErrorMessage(field: string) {
    if (this.newsfeedForm.get(field)?.hasError('required')) {
      return `${field} is required`;
    }
    if (this.newsfeedForm.get(field)?.hasError('invalidVideoUrl')) {
      return 'Please enter a valid video link.';
    }
    return '';
  }
  isDocument(fileType: string): boolean {
    return /pdf|msword|wordprocessingml|officedocument|presentation|spreadsheet|text\/plain/i.test(fileType);
  }
  onSelectBasicBannerImage(files: FileList, fileInput: HTMLInputElement) {
    if (!files || files.length === 0) {
      console.error("No files selected");
      return;
    }
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'video/mp4', 'audio/mpeg',  'application/pdf','application/msword',  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint','application/vnd.openxmlformats-officedocument.presentationml.presentation','text/plain'];
      if (!allowedTypes.includes(file.type)) {
        this.validationError = 'Invalid file type. Please upload JPG, JPEG, PNG, MP4, or PDF.';
        return;
      }
    const uniqueId = `${file.name}-${new Date().getTime()}`;
    
      
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.uploadedFiles.push({
          id: uniqueId,
          name: file.name,
          type: file.type,
          url: event.target.result,
        });
      };
      
      reader.readAsDataURL(file);
      const formData = new FormData();
      formData.append('directory', 'project');
      formData.append('file', file);
      this.mediaService.uploadMedia(formData).subscribe(response => {
        if (response && response.url) {
          this.imageurl.push({
            id: uniqueId,
            name: file.name,
            type: file.type,
            url: response.url,
          });
        const uploadedFileIndex = this.uploadedFiles.findIndex(f => f.id === uniqueId );
        if (uploadedFileIndex !== -1) {
          this.uploadedFiles[uploadedFileIndex].url = response.url;
        }
      }
      }, error => {
        console.error("Upload failed:", error);
      });
    }

    fileInput.value = '';
  }
    feedImageView(img: any) {
      if (img) {
        this._dialog.open(FeedImageComponent, {
          width: '40%',
          panelClass: ['custom-modal'],
          data:{  url: img.url, singleimage: true }
        })
      }
    }
    feedVideoView(video:any) {
      if (video) {
        this._dialog.open(FeedVideoComponent, {
          width: '40%',
          panelClass: ['custom-modal'],
          data: video
        })
      }
    }
    feeddocumentView(doc:any) {
      if (doc) {
        this._dialog.open(FeedDocumentComponent, {
          width: '40%',
          panelClass: ['custom-modal'],
          data: doc
        })
      }
    }
  

  removeFile(file: any) {
    this.uploadedFiles = this.uploadedFiles.filter(f => f.id !== file.id);
    this.imageurl = this.imageurl.filter(img => img.id !== file.id);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  async submitData() {
    if (this.newsfeedForm.invalid) {
      this.toast.openSnackBar('Please enter valid details');
      this.newsfeedForm.markAllAsTouched();
      return;
    }
    const loginData = this.sls.get('loginData');
    const EditPostImage = this.uploadedFiles;
    const formData = {
      ...this.newsfeedForm.value,
      user_role: loginData.type,
      user_id: loginData.id,
      status: this.isEditMode || loginData.type === 'ADMIN' ? 'PUBLISHED' : 'PENDING',
      post_image: this.isEditMode ? EditPostImage: this.imageurl,
      ...(loginData.type === "SUPPLIER" ? { dental_supplier_id: loginData.id } : {}),
      ...(loginData.type === "PROFESSIONAL" ? { dental_professional_id: loginData.id } : {}),
      ...(loginData.type === "PRACTICE" ? { dental_practice_id: loginData.id } : {}),
      ...(loginData.type === "ADMIN" ? { dental_admin_id: loginData.id } : {}),
    };
    let request: Promise<any>;
    if (this.isEditMode) {
      request = this.feedService.updateNewsfeedData(this.data.id, formData);
    } else {
      request = this.feedService.addNewsfeed(formData);
    }
  
    await request
      .then(() => {
        this.toast.openSnackBar(this.isEditMode ? 'NewsFeed Updated Successfully' : 'NewsFeed Submitted Successfully');
        this.dialogRef.close(true);
      })
      .catch((error) => {
        console.error("Operation failed:", error);
        this.toast.openSnackBar(this.isEditMode ? 'Failed to update NewsFeed' : 'Failed to submit NewsFeed');
      });
  }

 
  loadUserNewsfeeds(): void {
    this.isLoading = true;
    const loginData = this.sls.get('loginData');
    
    if (!loginData || !loginData.id || !loginData.type) {
      console.error('Login data not available');
      this.isLoading = false;
      return;
    }

    this.feedService.getNewsfeedsByUserId(loginData.id, loginData.type).subscribe({
      next: (feeds) => {
        this.newsfeeds = feeds;
        console.log("this.newsfeeds", this.newsfeeds)
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading newsfeeds:', err);
        this.isLoading = false;
      }
    });
  }
  


checkCategoryPermissions(): void {
    const loginData = this.sls.get('loginData');
    this.subscriptionPermissions = loginData?.subscription_permissions;
    
    // If no subscription permissions exist, show all categories without restrictions
    if (!this.subscriptionPermissions?.modules) {
      console.log('No subscription permissions found - showing all categories');
      this.feedService.getNewsFeedsCategories().subscribe({
        next: (categories) => {
          this.categoriesFilter = categories;
        },
        error: (err) => console.error('Error loading categories:', err)
      });
      return;
    }

    // Proceed with permission check if permissions exist
    const newsFeedPermission = this.subscriptionPermissions.modules.find(
      (module: any) => module.name === 'news_feed_modules_permission'
    );

    // If specific permission not found, treat as unlimited
    if (!newsFeedPermission) {
      console.log('No news feed permission found - showing all categories');
      this.feedService.getNewsFeedsCategories().subscribe({
        next: (categories) => {
          this.categoriesFilter = categories;
        },
        error: (err) => console.error('Error loading categories:', err)
      });
      return;
    }

    const allowedCategoryCount = newsFeedPermission.count;

    // Get all categories and user's newsfeeds
    this.feedService.getNewsFeedsCategories().subscribe({
      next: (allCategories) => {
        this.feedService.getNewsfeedsByUserId(loginData.id, loginData.type).subscribe({
          next: (feeds) => {
            // If count is 0 or negative, treat as unlimited
            if (allowedCategoryCount <= 0) {
              console.log('Unlimited categories allowed');
              this.categoriesFilter = allCategories;
              return;
            }

            // Count usage per category
            const categoryUsageMap = new Map<string, number>();
            feeds.forEach(feed => {
              const currentCount = categoryUsageMap.get(feed.category_type) || 0;
              categoryUsageMap.set(feed.category_type, currentCount + 1);
            });

            // Filter categories based on usage vs allowance
            this.categoriesFilter = allCategories.filter(category => {
              const usedCount = categoryUsageMap.get(category.id) || 0;
              return usedCount < allowedCategoryCount;
            });

            console.log('Available categories with usage count:',
              this.categoriesFilter.map(cat => ({
                id: cat.id,
                name: cat.category_name,
                remaining: allowedCategoryCount - (categoryUsageMap.get(cat.id) || 0)
              }))
            );
          },
          error: (err) => console.error('Error loading user feeds:', err)
        });
      },
      error: (err) => console.error('Error loading categories:', err)
    });
}



}
